import {Directive, ElementRef, inject} from '@angular/core';

/**
 * A directive that assigns a unique ID to the host HTML element.
 * This is particularly useful when unique identifiers are required for elements
 * to avoid conflicts or for accessibility purposes.
 *
 * The unique ID is generated using a random alphanumeric string and follows the pattern `unique-<randomString>`.
 * This ID is automatically applied to the `id` attribute of the host element upon instantiation.
 *
 * The directive does not require input or output properties, and the ID is generated internally each time the directive is applied.
 *
 * Selector: `[ngUniqueId]`
 */
@Directive({
    selector: '[ngUniqueId]',
})
export class UniqueElementIdDirective {

    private readonly element = inject(ElementRef<HTMLElement>);
    public readonly elementId = `unique-${Math.random().toString(36).substring(2, 9)}`

    constructor() {
        this.element.nativeElement.id = this.elementId;
    }
}
